import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import { useDispatch, useSelector } from 'react-redux';
import { Drawer, IconButton, List, Button } from '@material-ui/core';
import { Select, MenuItem, InputLabel, FormControl } from '@mui/material';
import { ArrowBack as ArrowBackIcon } from '@material-ui/icons';
import { useTheme } from '@material-ui/styles';
import { withRouter, Link } from 'react-router-dom';
import classNames from 'classnames';
import useStyles from './styles';
import SidebarLink from './components/SidebarLink/SidebarLink';
import sulogo from '../../assets/images/su-logo.svg';
import { getAllInstances } from '../../redux/Actions/instances.action';
import { getClient } from '../../redux/Actions/clientInfo.action';
import { getAllApps } from '../../redux/Actions/applications.action';
import { getUserInfo } from '../../redux/Actions/user.action';
import { sideBarState } from '../../redux/Actions/sidebar.action';

const { GET_CLIENT } = require('../../redux/Constants/client.constants');

const structure = [
    { id: 0, label: 'Dashboard', link: '/app/dashboard' },
    {
        id: 1,
        label: 'Incidents',
        link: '/app/incidents/list'
    },
    { id: 2, label: 'Applications', link: '/app/application' },
    {
        id: 3,
        label: 'API Usage',
        link: '/app/apiUsage'
    },
    { id: 5, type: 'divider' }
];

function Sidebar({ location }) {
    const dispatch = useDispatch();
    const classes = useStyles();
    const theme = useTheme();
    const sidebarStateValue = useSelector((state) => state.sidebar.isSideBarOpen);
    const [isPermanent, setPermanent] = useState(true);
    const instanceData = useSelector((state) => state.instance.allClients);
    let instances = [];
    if (instanceData[0] && instanceData[0].clients) {
        instances = instanceData[0].clients;
    }
    let tenantId = Cookies.get('tenantId') ? Cookies.get('tenantId') : '';
    const [value, setValue] = useState(tenantId);

    const setSidebarOpened = (value) => {
        dispatch(sideBarState(value));
    };

    const handleChange = (event) => {
        setValue(event.target.value);
        Cookies.set('tenantId', event.target.value);
        dispatch(getClient(event.target.value));
    };

    if (instances && instances.length > 0) {
        if (!instances.some((item) => item.tenantId === tenantId)) {
            tenantId = '';
        }
        if (tenantId === '') {
            setValue(instances[0].tenantId);
            Cookies.set('tenantId', instances[0].tenantId);
            handleChange({ target: { value: instances[0].tenantId } });
        }
    } else {
        dispatch({
            type: GET_CLIENT,
            data: {}
        });
    }

    useEffect(() => {
        if (value) {
            dispatch(getClient(value));
        }
    }, [value]);

    useEffect(() => {
        dispatch(getAllInstances({}));
        dispatch(getAllApps());
        dispatch(getUserInfo());
        window.addEventListener('resize', handleWindowWidthChange);
        handleWindowWidthChange();
        return function cleanup() {
            window.removeEventListener('resize', handleWindowWidthChange);
        };
    }, []);

    return (
        <Drawer
            variant={isPermanent ? 'permanent' : 'temporary'}
            className={classNames(classes.drawer, {
                [classes.drawerOpen]: sidebarStateValue,
                [classes.drawerClose]: !sidebarStateValue
            })}
            classes={{
                paper: classNames({
                    [classes.drawerOpen]: sidebarStateValue,
                    [classes.drawerClose]: !sidebarStateValue
                })
            }}
            open={sidebarStateValue}
        >
            <div className={classes.toolbar} />
            <div className={classes.mobileBackButton}>
                <IconButton
                    className={classes.backButtonWrapper}
                    onClick={() => setSidebarOpened(!sidebarStateValue)}
                >
                    <ArrowBackIcon
                        classes={{
                            root: classNames(classes.headerIcon, classes.headerIconCollapse)
                        }}
                    />
                </IconButton>
                <div className={classes.logotype}>
                    <img className={classes.logotypeIcon} src={sulogo} alt="logo" width="140" />
                </div>
            </div>
            <div className={classes.selectWrapper}>
                <FormControl variant="filled" className={classes.selectFromControl}>
                    <InputLabel id="client-select-label" className={classes.selectLabel}>
                        Select an Instance
                    </InputLabel>
                    <Select
                        labelId="client-select-label"
                        id="client-select-box"
                        value={value}
                        onChange={handleChange}
                        label="Select an Instance"
                        className={classes.selectLabel}
                        displayEmpty
                        inputProps={{
                            'aria-label': 'Without label',
                            classes: {
                                icon: classes.selectIcon
                            }
                        }}
                        disableUnderline
                    >
                        {instances.map((item) => (
                            <MenuItem value={item.tenantId} key={item.tenantId}>
                                {item.name}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </div>
            <List className={classes.sidebarList}>
                {structure.map((link) => (
                    <SidebarLink
                        key={link.id}
                        location={location}
                        sidebarStateValue={sidebarStateValue}
                        {...link}
                    />
                ))}
            </List>
            <Button
                variant="outlined"
                component={Link}
                to="/app/incidents/create"
                className={classes.createIncidentButton}
            >
                Create new Incident
            </Button>
            <div className={classes.toolbar} />
        </Drawer>
    );

    function handleWindowWidthChange() {
        const windowWidth = window.innerWidth;
        const breakpointWidth = theme.breakpoints.values.md;
        const isSmallScreen = windowWidth < breakpointWidth;

        if (isSmallScreen && isPermanent) {
            setPermanent(false);
        } else if (!isSmallScreen && !isPermanent) {
            setPermanent(true);
        }
    }
}

export default withRouter(Sidebar);
